import React from "react";
import { Box, Button, Container } from "@mui/material";
import "./SubCategories.css";
import { Link } from "react-router-dom";

const SubCategories = ({ subCategories }) => {
	return (
		<Container maxWidth="xl">
			<Box className="subsContainer">
				{subCategories.map((subcategory) => (
					<Link
						to={subcategory.routeURL}
						className="subCategoriesLink"
						key={subcategory.idSubCategory}
					>
						<Button
							className="btnAddToCart"
							variant="contained"
							color="secondary"
							fullWidth
							sx={{
								mt: 0.0,
								fontSize: ".8rem",
								fontWeight: 700,
								textAlign: "center",
								width: "fit-content",
							}}
						>
							{subcategory?.name}
						</Button>
					</Link>
				))}
			</Box>
		</Container>
	);
};

export default SubCategories;
